import React from 'react';
import PageKit from '../PageKit';
import { useTranslation } from 'react-i18next';
import Slidebar from '../component/Slidebar';

function ConnectedDevices() {
  const { t } = useTranslation();

  const text = t('ConnectedDevices.Text');

  // Images depuis le dossier public/img/ConnectedDevices
  // no lightbox on this page per request

  const images = [
    `${process.env.PUBLIC_URL}/img/ConnectedDevices/laser1.png`,
    `${process.env.PUBLIC_URL}/img/ConnectedDevices/laser2.jpg`,
    `${process.env.PUBLIC_URL}/img/ConnectedDevices/laser3.jpg`,
    `${process.env.PUBLIC_URL}/img/ConnectedDevices/Pedals.jpg`,
    `${process.env.PUBLIC_URL}/img/ConnectedDevices/gloves.jpg`,
  ];

  const captions = [
    t('ConnectedDevices.Captions.0'),
    t('ConnectedDevices.Captions.1'),
    t('ConnectedDevices.Captions.2'),
    t('ConnectedDevices.Captions.3'),
    t('ConnectedDevices.Captions.4'),
  ];

  return (
    <PageKit>
      <div style={{ padding: '56px 10vw 36px 10vw', color: 'white' }} className="global-background">
        <div style={{ width: '100%', textAlign: 'center', fontSize: '2.2rem', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', marginBottom: '28px', textShadow: '0 2px 12px #0078d455' }}>
          {t('ExpertiseTile.ConnectedDevicesTitle')}
        </div>

        {/* Unique encart de texte */}
        <div style={{
          background: 'rgba(24, 28, 48, 0.72)',
          borderRadius: '24px',
          padding: '32px',
          marginBottom: '28px',
          // shadow removed as requested
          border: '1.5px solid #222a37'
        }}>
          <p style={{ fontSize: '1.15rem', lineHeight: 1.85, color: '#eaf6ff', margin: 0 }}>{text}</p>
        </div>

        {/* Carousel d'images (style similaire aux projets de la page d'accueil) */}
        <div style={{
          background: 'rgba(24, 28, 48, 0.72)',
          borderRadius: '24px',
          padding: '8px 0 20px 0',
          // shadow removed as requested
          border: '1.5px solid #222a37'
        }}>
          <Slidebar>
            {images.map((src, i) => (
              <div key={i} style={{
                width: '360px',
                background: 'rgba(16, 20, 36, 0.65)',
                border: '1px solid #222a37',
                borderRadius: '16px',
                padding: '10px',
                marginRight: '16px'
              }}>
                <img
                  src={src}
                  alt={`Connected device ${i+1}`}
                  style={{ width: '100%', borderRadius: '10px', border: '1px solid #0078d422', objectFit: 'cover', aspectRatio: '16 / 9' }}
                />
                <div style={{
                  color: '#bddfff',
                  fontSize: '0.98rem',
                  lineHeight: 1.6,
                  textAlign: 'center',
                  marginTop: '10px'
                }}>
                  {captions[i] || `Image ${i+1}`}
                </div>
              </div>
            ))}
          </Slidebar>
        </div>
      </div>
    </PageKit>
  );
}

export default ConnectedDevices;
